import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const formatDate = (isoDate: string) => {
  const date = new Date(isoDate);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(date.getMonth() + 1)}/${pad(
    date.getDate(),
  )}/${date.getFullYear()} ${pad(date.getHours())}:${pad(
    date.getMinutes(),
  )}:${pad(date.getSeconds())}`;
};

const getFormattedDateRange = (csvExportCriteria: string) => {
  if (!csvExportCriteria) return '';
  const { CsvExportStartDate, CsvExportEndDate } =
    JSON.parse(csvExportCriteria);
  return `${dayjs(CsvExportStartDate).format('MM/DD/YYYY H:mm:ss')} - ${dayjs(
    CsvExportEndDate,
  ).format('MM/DD/YYYY H:mm:ss')}`;
};

type MultiSelectInputType = {
  label?: string;
  value: number;
};

function getSourceSearchValue(source?: MultiSelectInputType[]): string {
  const safeSource = source ?? [];

  const hasSelectAll = safeSource.some(item => item.value === 0);

  const values = safeSource
    .filter(item => item.value !== 0)
    .map(item => item.value);

  // Select All checked
  if (hasSelectAll) return '';

  // Unselected (cleared)
  if (values.length === 0) return 'blank';

  if (values.includes(1) && values.includes(2)) return '';

  if (values.length === 1 && values[0] === 1) return 'true';

  if (values.length === 1 && values[0] === 2) return 'false';

  return 'blank';
}

function getStartDate(): string {
  const startDate = dayjs()
    .subtract(29, 'day')
    .startOf('day')
    .format('MM/DD/YYYY HH:mm:ss');

  const endDate = dayjs().endOf('day').format('MM/DD/YYYY HH:mm:ss');

  return `${startDate} - ${endDate}`;
}

export {
  formatDate,
  getFormattedDateRange,
  getSourceSearchValue,
  getStartDate,
};
